import { useI18nSync } from "@app/shared/lib/Hooks/useI18nSync.ts";
import { useConfigContext } from "@entities/game/model/useConfigContext.ts";
import { AppConfig } from "@fxid/shared";
import { useEffect, useMemo } from "react";

import MainRoutes from "./MainRoutes.tsx";
import SingleGameSiteRoutes from "./SingleGameSiteRoutes.tsx";

/**
Выбирает, какой набор роутов отображать, на основе результатов
основного запроса chooseGame.
 */
const AppRouter = () => {
	useI18nSync();
	const { platformData } = useConfigContext();

	// Логика определения режима сайта.
	const isSingleGameSite = useMemo(() => !!(AppConfig.game ?? import.meta.env.VITE_APP_GAME_OVERRIDE), []);

	useEffect(() => {
		log.debug("AppRouter: Context loaded successfully, rendering routes.");
	}, []);

	// Оборачиваем роуты в MantineProvider, чтобы применить тему
	return <>{isSingleGameSite ? <SingleGameSiteRoutes /> : <MainRoutes />}</>;
};
export default AppRouter;
